<style lang="scss">
  :global(.cpnav svg:focus) {
    outline: 0;
  }
</style>

<script lang="ts">
  import { get } from 'svelte/store'
  import { getIconAttrs } from '@lib/images/images'

  import PassportIcon from '@nav/images/passport.svg'
  import { NavContainer } from '@packages/ui'

  import { AUTH_PROVIDERS, NavDirections, Themes } from '@packages/utils/enums'
  import type { TNavConfig } from '@packages/utils/types'
  import { isLoggedInStore, fn, clientPublicStore } from '@packages/stores'
  import { onDestroy } from 'svelte'

  import { on, PassportEvents } from '@lib/events/events'
  import { cloakStore, configStore } from '@src/stores/config'
  import ExpandedNav from './components/ExpandedNav.svelte'
  import { resolveNavbarOverrideImage } from '@packages/utils/lib/navbarOverride'

  export let styles: { [key: string]: string }

  export let navConfig: TNavConfig

  const config = get(configStore)
  const { openUI, getBalance: getSuiBalance, login } = get(fn)

  let balance: string = ''

  const getBalance = async () => {
    balance = `${await getSuiBalance()} ${$clientPublicStore?.ui_settings.cred_alias || 'cred'}`
  }

  const offRecheckBalanceListener = on(PassportEvents.RECHECK_BALANCE, async () => {
    // to be fixed later. Sui balance is not updated after right transaction
    setTimeout(() => getBalance(), 3000)
  })

  const offUserAddressListener = on(PassportEvents.LOGIN, async () => {
    await getBalance()
  })

  $: $isLoggedInStore && $configStore.suiNetwork && getBalance()

  $: navbarOverrideImage = resolveNavbarOverrideImage(
    $clientPublicStore?.ui_settings,
    $isLoggedInStore,
  )

  $: uiStyleEntries = Object.entries($clientPublicStore?.ui_settings || {})
    .filter(([key]) => !key.endsWith('_url'))
    .map(([key, value]) => {
      if (key === 'text_color') {
        return ['color', value]
      }
      return [`${key.replace(/_/g, '-')}`, value]
    })

  $: combined = {
    ...styles,
    ...Object.fromEntries(uiStyleEntries),
  }

  $: cssVarStyles = Object.entries(combined)
    .map(([key, value]) => `${key}:${value} !important`)
    .join(';')

  let isExpanded: boolean = false
  let isMinimized: boolean = navConfig.minimization?.enabled || false
  const navDirection = config.nav?.direction || NavDirections.TOP
  const theme = config.nav?.theme || Themes.WHITE

  let chevronStyles = ''
  $: {
    chevronStyles = Object.entries({
      // safari doesn't respect transform as a direct attribute
      ...(isExpanded ? { transform: 'scale(1, -1)' } : {}),
      ...getIconAttrs(theme),
    })
      .map(([key, value]) => `${key}:${value}`)
      .join(';')
  }

  const iconStyles = Object.entries(getIconAttrs(theme))
    .map(([key, value]) => `${key}:${value}`)
    .join(';')

  const loggedInStoreUnSub = isLoggedInStore.subscribe((isLoggedIn) => {
    if (!isLoggedIn) isExpanded = false
  })

  onDestroy(() => {
    offRecheckBalanceListener()
    offUserAddressListener()
    loggedInStoreUnSub()
  })

  const onClickHadle = async () => {
    if (!$cloakStore) {
      await login(AUTH_PROVIDERS.OAUTH)
    } else {
      openUI()
    }
  }
</script>

<NavContainer
  options={{
    isExpanded,
    theme,
    isMinimized,
    cssVarStyles,
    navConfig,
    navDirection,
    iconStyles,
    onItemClicked: (page) => openUI(page),
    expandedNavComponent: ExpandedNav,
    navbarOverrideImage,
  }}
  navItemOptions={{
    onClick: () => ($isLoggedInStore ? (isExpanded = !isExpanded) : onClickHadle()),
    title: $clientPublicStore.name,
    passIcon: $clientPublicStore.ui_settings.logo_url || PassportIcon,
    chevronStyles,
  }}
  balanceOptions={{
    isShown: true, //config.buyTokens !== false && !!erc20CredTokens[config.chainId]?.address,
    balance,
  }}
></NavContainer>
